const actions = {
  SET_STATE: 'categories/SET_STATE',
  UPDATE_STATE: 'categories/UPDATE_STATE',
  LOAD_DATA: 'categories/LOAD_DATA',
  CLEAR_STATE: 'categories/CLEAR_STATE',
};

export default actions;
